var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptOpenSecretWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#252A41",
    d: "M19.3 9.87L4.22 7.97c-.7-.09-1.35.42-1.44 1.12l-1.2 9.55c-.09.72.41 1.36 1.12 1.45l15.08 1.9c.71.09 1.35-.41 1.44-1.12l1.2-9.55c.09-.71-.41-1.36-1.12-1.45zm-8.07 8.62l-1.32-.17.85-6.73 1.32.17-.85 6.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.89 10.29l-.3-1.63c-.61-3.28 1.57-6.44 4.85-7.05 3.28-.61 6.44 1.57 7.05 4.85l1.48-.27A7.556 7.556 0 0010.16.13c-4.1.76-6.82 4.7-6.06 8.81l.3 1.63 1.49-.28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptOpenSecretWhite);
export default __webpack_public_path__ + "static/media/recrypt_open_secret_white.e6a56488.svg";
export { ForwardRef as ReactComponent };